var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#169154",
    d: "M15 1H7.046C6.47 1 6 1.469 6 2.046v4.356h9V1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18482A",
    d: "M6 17.232v4.322c0 .577.469 1.046 1.046 1.046H15v-5.368H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8045",
    d: "M6 6.402h9v5.401H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17472A",
    d: "M6 11.803h9v5.43H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29C27F",
    d: "M22.954 1H15v5.402h9V2.046C24 1.47 23.531 1 22.954 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27663F",
    d: "M15 17.232V22.6h7.954c.577 0 1.046-.469 1.046-1.046v-4.321h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19AC65",
    d: "M15 6.402h9v5.401h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#129652",
    d: "M15 11.803h9v5.43h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C7238",
    d: "M10.991 17.8H1.01A1.01 1.01 0 010 16.791V6.81C0 6.252.452 5.8 1.009 5.8h9.982A1.01 1.01 0 0112 6.809v9.982a1.01 1.01 0 01-1.009 1.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.484 8.8h1.432l1.161 2.252L7.305 8.8h1.337l-1.842 3 1.884 3h-1.41l-1.266-2.358L4.747 14.8H3.316l1.915-3.011z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}

export default SvgAppExcel;